import ErrorMessage from "./ErrorMessage";
import AuthorizedErrorMessage from "./AuthorizedErrorMessage";

export { AuthorizedErrorMessage };
export default ErrorMessage;
